/*!

 =========================================================
 * Vue Paper Dashboard - v1.0.1
 =========================================================

 * Product Page: http://www.creative-tim.com/product/paper-dashboard
 * Copyright 2023 Creative Tim (http://www.creative-tim.com)
 * Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard/blob/master/LICENSE.md)

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */
import Vue from "vue";
import App from "./App";
import router from "./router/index";
import i18n, { initializeLocale } from "./i18n";
import { captureSignupAttribution } from "@/api/session";
import { captureAffiliateAttribution } from "@/utils/affiliateAttribution";
import { initSentry } from "@/utils/sentry";

initSentry(Vue);
initializeLocale();
captureSignupAttribution();
captureAffiliateAttribution();

import PaperDashboard from "./plugins/paperDashboard";
import "vue-notifyjs/themes/default.css";
import "./assets/css/clipr-theme.css";
import { PiniaVuePlugin } from "pinia";
import fullCalendar from 'vue-full-calendar';
import pinia from "./stores";

// Importar CSS de FullCalendar
require('vue-full-calendar/node_modules/fullcalendar/dist/fullcalendar.css');

Vue.use(PaperDashboard);
Vue.use(PiniaVuePlugin);
Vue.use(fullCalendar);

/* eslint-disable no-new */
new Vue({
  router,
  pinia,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
